module.exports = __webpack_public_path__ + "static/media/all_road_c.326224fa.tif";